import { render, staticRenderFns } from "./Commentaires.vue?vue&type=template&id=7c4a355c&"
import script from "./Commentaires.vue?vue&type=script&lang=js&"
export * from "./Commentaires.vue?vue&type=script&lang=js&"
import style0 from "./Commentaires.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports